import Waves from "node-waves";
import Radium from "radium";
import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { connect } from "react-redux";
import auth from "../../../Login/authService";
import { addAlert } from "../../../MsgNotify/msgNotifyActions";
import { httpGet, httpPost } from "../../../Util/http";

import Modal from "../../../Common/modal";
import Dokumenter from "./Apvs/dokumenter";

class Arbejdsmiljo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usedProductsKey: 1,
      suggiValue: { id: "", name: "" },
      showInfoWorkplace: false,
      showSafetyWorkplace: false,
      showUsageTooltip: false,
      showDocuments: true,
      showDatablade: false,
      showAPV: true,
      hide: true,
      loading: false,
      selected: {},
      apvs: [],
      document: undefined,
      employees: {},
      data: {
        name: "Docs",
        root: "root",
        toggled: true,
        children: [],
      },
    };
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle(node, toggled) {
    if (this.state.cursor) {
      this.state.cursor.active = false;
    }
    node.active = true;

    if (node.name !== "Docs") {
      if (node.children) {
        node.toggled = toggled;
      }
    }

    this.setState({ cursor: node });
  }

  replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find, "g"), replace);
  };

  componentWillMount() {
    const _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/arbejdsmiljo/" +
      this.props.params.workplaceId.slice(0, -3) +
      "d0c" +
      "/save";

    httpGet(_url)
      .then((resp) => resp.json())
      .then((json) => {
        if (!json) {
          return;
        }
        let rep = this.replaceAll(
          json.documentState,
          '"toggled": true',
          '"toggled": false'
        );
        let rep2 = this.replaceAll(rep, '"active": true', '"active": false');
        let a = JSON.parse(rep2);
        a.data.toggled = true;
        a.data.children[0].toggled = true;
        this.setState({
          selected: a.selected,
          data: a.data,
        });
        return a.selected;
      })
      .catch((e) => {
        console.log(e);
        this.props.dispatch(addAlert("Kunne ikke hente docs"));
      });
  }
  componentDidMount() {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  }
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  toggleApv = (apv) => {
    if (auth.getProfile().role === "Formand") {
      this.setState({
        showDocuments: true,
      });
      return;
    }

    let sel = this.state.selected;
    if (sel[apv.id]) {
      delete sel[apv.id];
      let i = null;
      this.state.data.children[0].children.forEach((c, index) => {
        if (c.id === apv.id) {
          i = index;
        }
      });
      this.state.data.children[0].children.splice(i, 1);
    } else {
      apv.apv = true;
      sel[apv.id] = apv;
      this.state.data.children[0].children.push(apv);
    }
    this.setState({
      selected: sel,
      showDocuments: true,
    });
    this.saveDocumentTree();
  };
  saveDocumentTree = () => {
    let storeObj = {
      selected: this.state.selected,
      data: this.state.data,
    };
    const _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/arbejdsmiljo/" +
      this.props.params.workplaceId.slice(0, -3) +
      "d0c" +
      "/savetree?documentState=" +
      JSON.stringify(storeObj);
    httpPost(_url).catch((e) => {
      this.props.dispatch(addAlert("Kunne ikke opdatere docs"));
    });
  };
  show = (node, type, value, filename) => {
    if (!type) {
      if (node.document.fileUrl.indexOf(".pdf") !== -1) {
        this.setState({
          hide: false,
          document: { url: node.document.fileUrl },
          loading: true,
        });
      } else if (
        node.document.fileUrl.indexOf(".jpg") !== -1 ||
        node.document.fileUrl.indexOf(".jpeg") !== -1 ||
        node.document.fileUrl.indexOf(".png") !== -1 ||
        node.document.fileUrl.indexOf(".gif") !== -1 ||
        node.document.fileUrl.indexOf(".tiff") !== -1
      ) {
        {
          this.setState({
            hide: false,
            document: { img: node.document.fileUrl },
          });
        }
      } else {
        window.open(node.document.fileUrl);
      }
    } else if (type === "RENAME") {
      let s = this.state.data;
      let obj = s.children[node.i];
      obj.done = false;
      obj.name = value;
      this.setState({
        data: s,
      });
    } else if (type === "RENAME_STATE") {
      let s = this.state.data;
      let obj = s.children[node.i];
      obj.done = false;
      this.setState({
        data: s,
      });
    } else if (type === "DELETE_FOLDER") {
      if (node.goahead) {
        let state = this.state.data;
        state.children.splice(node.i, 1);
        this.setState({
          data: state,
        });
        this.saveDocumentTree();
      } else {
        let state = this.state.data;
        let o = state.children[node.i];
        o.goahead = true;
        this.setState({
          data: state,
        });
      }
    } else if (type === "ANNULLER_FOLDER") {
      let state = this.state.data;
      let o = state.children[node.i];
      o.goahead = false;
      this.setState({
        data: state,
      });
    } else if (type === "DONE") {
      let s = this.state.data;
      let obj = s.children[node.i];
      obj.done = true;
      this.setState({
        data: s,
      });
      this.saveDocumentTree();
    } else if (type === "FILEUPLOAD") {
      const _url =
        process.env.REACT_APP_webApiEndPoint +
        "api/arbejdsmiljo/" +
        this.props.params.workplaceId.slice(0, -3) +
        "d0c" +
        "/save";
      httpPost(_url, {
        document: {
          name: filename,
          fileUrl: value.split(",")[1],
        },
      })
        .then((resp) => resp.json())
        .then((json) => {
          let state = this.state.data;
          state.children[node.i].children.push({
            id: json.apvId,
            i: node.i,
            name: filename,
            document: {
              fileUrl: json.document.fileUrl,
            },
            toggled: true,
          });
          this.setState({
            data: state,
          });
          this.saveDocumentTree();
        })
        .catch((e) => {
          this.props.dispatch(addAlert("Kunne ikke uploade doc"));
        });
    } else if (type === "DELETE") {
      if (node.goahead) {
        let state = this.state.data;
        let indexO = 0;
        for (
          var i = 0, len = state.children[node.i].children.length;
          i < len;
          i++
        ) {
          if (state.children[node.i].children[i].id === node.id) {
            indexO = i;
            break;
          }
        }
        state.children[node.i].children.splice(indexO, 1);
        this.setState({
          data: state,
        });
        this.saveDocumentTree();
      } else {
        let state = this.state.data;
        let indexO = 0;
        for (
          var i = 0, len = state.children[node.i].children.length;
          i < len;
          i++
        ) {
          if (state.children[node.i].children[i].id === node.id) {
            indexO = i;
            break;
          }
        }
        let o = state.children[node.i].children[indexO];
        o.goahead = true;
        this.setState({
          data: state,
        });
      }
    } else if (type === "ANNULLER") {
      if (node.goahead) {
        let state = this.state.data;
        let indexO = 0;
        for (
          var i = 0, len = state.children[node.i].children.length;
          i < len;
          i++
        ) {
          if (state.children[node.i].children[i].id === node.id) {
            indexO = i;
            break;
          }
        }
        let o = state.children[node.i].children[indexO];
        o.goahead = false;
        this.setState({
          data: state,
        });
      }
    } else if (type === "FOLDER") {
      let state = this.state.data;
      state.children.push({
        i: state.children.length,
        name: "Ny mappe",
        toggled: true,
        children: [],
      });
      this.setState({
        data: state,
      });
    } else {
    }
  };

  render() {
    return (
      <div style={styles.container}>
        {!this.state.hide ? (
          <div
            style={{
              position: "absolute",
              top: -40,
              width: "100%",
              height: "105%",
            }}
          >
            <Modal
              hide={this.state.hide}
              onClose={() => {
                this.setState({ hide: !this.state.hide, document: undefined });
              }}
            >
              {this.state.loading ? (
                <i
                  style={{ color: "white" }}
                  className="fa fa-spinner fa-spin fa-3x fa-fw"
                ></i>
              ) : null}
              {this.state.document ? (
                this.state.document.img ? (
                  <img
                    key={this.state.document.img}
                    src={this.state.document.img}
                    height="auto"
                    width="auto"
                    style={{ maxHeight: "90%", maxWidth: "90%" }}
                    alt="chat"
                  ></img>
                ) : (
                  <iframe
                    title="dpdf1"
                    scrolling="no"
                    width="100%"
                    height="95%"
                    src={
                      "https://docs.google.com/viewer?url=" +
                      this.state.document.url +
                      "&embedded=true"
                    }
                    onLoad={() =>
                      this.setState({
                        loading: false,
                      })
                    }
                  ></iframe>
                )
              ) : null}
            </Modal>
          </div>
        ) : null}
        {/* content */}
        <div style={styles.contentContainer}>
          <div style={[styles.column, { width: "95%" }]}>
            <Scrollbars style={{ width: "100%", height: "100%" }}>
              <div style={{ width: "98%", height: "100%" }}>
                <div
                  style={{
                    cursor: "pointer",
                    backgroundColor: "rgb(238, 238, 238)",
                    marginTop: "15px",
                  }}
                  onClick={() =>
                    this.setState({ showDocuments: !this.state.showDocuments })
                  }
                >
                  <h3
                    style={{
                      textAlign: "center",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    Docs
                    <i
                      style={{ paddingLeft: 10 }}
                      className={
                        this.state.showDocuments
                          ? "fa fa-caret-up"
                          : "fa fa-caret-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </h3>
                </div>
                {this.state.showDocuments ? (
                  <div style={{ border: "5px solid rgb(238, 238, 238)" }}>
                    <Dokumenter
                      apvs={this.state.selected}
                      data={this.state.data}
                      show={this.show}
                      onToggle={this.onToggle}
                    />
                  </div>
                ) : null}
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    "@media (min-width: 1200px)": {
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: "1170px",
      width: "100%",
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingTop: 5,
  },
  column: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "100%",
  },
  border: {
    border: "2px solid lightgrey",
  },
};

const selectProps = (state) => {
  return {
    ...state.arbejdsmiljoReducer,
    ...state.dailyReportUsageReducer,
  };
};

export default connect(selectProps)(Radium(Arbejdsmiljo));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/docs.js